





























































import 'swiper/dist/css/swiper.css';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import KnowMoreBtn from '@/components/know-more-button/Know-more-btn.vue';

import imgs from '@/util/imgs.ts';

@Component({
  components: {
    swiper,
    swiperSlide,
    KnowMoreBtn,
  },
})
export default class Swiper extends Vue {
  private imgs = imgs;
  private swiperOption = {
    // Basic 一般选项
    speed: 1600,
    // Loop 环路
    loop: true,
    /* 组件 */
    // Autoplay 自动切换
    autoplay: true,
    // disableOnInteraction: false,
    // Effect 切换效果
    // effect: 'fade',
    // Pagination 分页器
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    // Navigation Buttons 前进后退按钮
    // navigation: {
    //   nextEl: '.swiper-button-next',
    //   prevEl: '.swiper-button-prev',
    // },
    // Lazy Loading 延迟加载
    // lazy: {
    //   loadPrevNext: true
    // }
  };

  @Watch('$store.state.lang')
  private onLangChanged() {
    const myswiper = this.$refs.mySwiper as any;
    // 解决中英切换问题
    this.$nextTick(() => {
      myswiper.swiper.loopDestroy();
      myswiper.swiper.loopCreate();
    });
  }

  private gotoAboutPage() {
    // window.console.log('gotoAboutPage');
    this.$router.push('/about');
  }

  private gotoSinglePage() {
    this.$router.push('/single');
  }

  private playVideo() {
    this.$emit('play-video');
  }
}
